var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"program"},[(_vm.icon)?_c('div',{staticClass:"program-image"},[_c('CustomIcon',{attrs:{"name":_vm.icon}})],1):_vm._e(),_c('div',{staticClass:"program-content"},[_c('h4',{staticClass:"program-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"program-description"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }